import React from "react";
import { useField, useFormikContext } from "formik";
import ErrorField from "../errorField";
import FormGroup from "../formGroup";
import TextArea from "../../core/textarea";
import { FormTextAreaFieldCustomProps } from "../types";
import { FieldResetWhenRemoved } from "shared/form/util";
import FieldKiPehchan from "../fieldKiPehchan";

function FormTextAreaFieldCustom({ fullWidth = true, ...props }: FormTextAreaFieldCustomProps) {
  const { setFieldTouched, setFieldValue, validateForm, validateOnChange } = useFormikContext();
  const [{ ...field }, meta] = useField({
    name: props.name,
    validate: props.validate
  });

  const changeHandler = React.useCallback(
    async e => {
      await setFieldValue(props.name, e.target.value, false);
      if (!meta.touched) {
        await setFieldTouched(props.name, true, false);
      }
      validateOnChange && (await validateForm());
    },
    [setFieldValue, setFieldTouched, validateForm, props.name, meta.touched, validateOnChange]
  );

  return (
    <React.Fragment>
      <FormGroup className={props.className} fullWidth={fullWidth} indented={props.indented}>
        <FieldKiPehchan label={props.label} />

        <TextArea
          name={props.name}
          value={field.value}
          onBlur={field.onBlur}
          onChange={changeHandler}
          placeholder={props.placeholder}
          rows={props.rows}
          autoFocus={props.autoFocus}
          hasError={meta.touched && meta.error}
          disabled={props.disabled}
          maxCount={props.maxCount}
        />
        {props.customComponent}
        <ErrorField meta={meta} />
        {props.enableFieldReset && <FieldResetWhenRemoved name={props.name} />}
      </FormGroup>
    </React.Fragment>
  );
}

export default FormTextAreaFieldCustom;
